import RunStateBadge from "components/Run/elements/StateBadge";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableRow } from "../../../gql";
import { getModulePullRequestSingleRun, getModulePullRequestState } from "../../../helpers";
import ModulePullRequestStateBadge from "../../../StateBadge";
import ModulePullRequestsTableGroupCell from "../../GroupCell";

const ModulePullRequestsTablePullRequestStatusCell = ({
  item: pullRequest,
  ...cellProps
}: TableSimpleCellProps<ModulePullRequestsTableRow>) => {
  const singleRun = getModulePullRequestSingleRun(pullRequest.runs);
  const aggregateState = singleRun ? undefined : getModulePullRequestState(pullRequest.runs);

  return (
    <ModulePullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      {!singleRun && !aggregateState && <TableCellEmpty />}

      {!!aggregateState && <ModulePullRequestStateBadge state={aggregateState} />}

      {!!singleRun && <RunStateBadge state={singleRun.state} />}
    </ModulePullRequestsTableGroupCell>
  );
};

export default ModulePullRequestsTablePullRequestStatusCell;
